import { useCallback } from 'react';
import { useConfig } from '../bootstrap/ConfigProvider';

const usePasswordRequirements = () => {
    const { passwordRequirements: pr } = useConfig();

    const verify = useCallback(
        password => {
            const errors = {};

            if (password.length < pr.requiredLength) {
                errors.length = true;
            }
            if (pr.requireLowercase && !/[a-z]/.test(password)) {
                errors.lowerCase = true;
            }
            if (pr.requireUppercase && !/[A-Z]/.test(password)) {
                errors.upperCase = true;
            }
            if (pr.requireDigit && !/[0-9]/.test(password)) {
                errors.numeric = true;
            }
            if (pr.requireNonAlphanumeric && !/[^a-zA-Z0-9]/.test(password)) {
                errors.specialChar = true;
            }

            return errors;
        },
        [
            pr.requiredLength,
            pr.requireDigit,
            pr.requireLowercase,
            pr.requireNonAlphanumeric,
            pr.requireUppercase
        ]
    );

    return verify;
};

export default usePasswordRequirements;
